"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.create");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.set-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _colorPicker = require("../components/color-picker");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Touchable =
/*#__PURE__*/
_native["default"].TouchableOpacity(function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return {
    borderColor: theme.borderColor,
    width: 30,
    height: 20,
    borderRadius: 2,
    borderWidth: 1,
    margin: 10,
    backgroundColor: color
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var ColorType =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ColorType, _React$Component);

  function ColorType(props) {
    var _this;

    _classCallCheck(this, ColorType);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColorType).call(this, props));

    _this.openColorPicker = function () {
      _this.setState({
        displayColorPicker: true
      });
    };

    _this.closeColorPicker = function () {
      _this.setState({
        displayColorPicker: false
      });
    };

    _this.onChangeColor = function (color) {
      var onChange = _this.props.onChange;
      onChange((0, _colorPicker.fromHsv)(color));
    };

    _this.state = {
      displayColorPicker: false
    };
    return _this;
  }

  _createClass(ColorType, [{
    key: "render",
    value: function render() {
      var knob = this.props.knob;
      var displayColorPicker = this.state.displayColorPicker;
      return _react["default"].createElement(_reactNative.View, null, _react["default"].createElement(Touchable, {
        color: knob.value,
        onPress: this.openColorPicker
      }), _react["default"].createElement(_reactNative.Modal, {
        supportedOrientations: ['portrait', 'landscape'],
        transparent: true,
        visible: displayColorPicker,
        onRequestClose: this.closeColorPicker
      }, _react["default"].createElement(_reactNative.TouchableWithoutFeedback, {
        onPress: this.closeColorPicker
      }, _react["default"].createElement(_reactNative.View, {
        style: {
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, _react["default"].createElement(_reactNative.TouchableWithoutFeedback, null, _react["default"].createElement(_reactNative.View, {
        style: {
          backgroundColor: 'white',
          borderWidth: 1,
          borderColor: 'rgb(247, 244, 244)',
          width: 250,
          height: 250,
          padding: 10
        }
      }, _react["default"].createElement(_reactNative.TouchableOpacity, {
        onPress: this.closeColorPicker,
        style: {
          alignSelf: 'flex-end',
          padding: 5
        }
      }, _react["default"].createElement(_reactNative.Text, {
        style: {
          fontSize: 18,
          fontWeight: 'bold'
        }
      }, "X")), _react["default"].createElement(_colorPicker.ColorPicker, {
        onColorSelected: this.onChangeColor,
        defaultColor: knob.value,
        style: {
          flex: 1
        }
      })))))));
    }
  }]);

  return ColorType;
}(_react["default"].Component);

ColorType.propTypes = {
  knob: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].string
  }),
  onChange: _propTypes["default"].func
};
ColorType.defaultProps = {
  knob: {},
  onChange: function onChange(value) {
    return value;
  }
};

ColorType.serialize = function (value) {
  return value;
};

ColorType.deserialize = function (value) {
  return value;
};

var _default = ColorType;
exports["default"] = _default;